import { ProductService } from "@/services/nextshop/product.service";

export async function checkSerialExist(serial, sku) {
  try {
    let params = {
      queryString: sku != undefined ? `{sku} != '''${sku.trim()}''' and {serieNo} =='''${serial.trim()}'''` : "{serieNo}=='''"+`${serial.trim()}`+"'''",
      limit: 100,
      lastIndex: ''
    }
    // fix serials trùng khi đã check out serials
    params.queryString+= ` and {serieStatus} in ['''IN_STOCK''', '''OUT''']`
    const response = await ProductService.getProductSeriesEmei(params)
    if (response.success) {
      return response.data
    }
  } catch (error) {
    return { data: {}, message: error.message }
  }
}
export async function checkSerialItem(sku) {
  try {
    const params = {
      queryString: "{sku}=='''"+`${sku.trim()}`+"''' and {serieStatus}=='''IN_STOCK''' and {isLocked}==false",
      limit: 100,
      lastIndex: ''
    }
    const response = await ProductService.getProductSeriesEmei(params)
    if (response.success) {
      return response.data
    }
  } catch (error) {
    return { data: {}, message: error.message }
  }
}
export async function checkSKU(sku) {
  const params = {
    pagingAndSorting: { limit: 10, lastIndex: "", sortOrder: "DESC" },
    queryString:
      "{variations.sku}=='''" + `${sku}` + "'''",
  };
  return await ProductService.getList(params)
}